import {
  Companion_instancevt78qdise4qh as Companion_instance,
  Event1xu0tgxxbb919 as Event,
  EventType2bd9gu34l4i61 as EventType,
} from './shared.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance,
  UUID21wrnrlmk5y1y as UUID,
} from '../../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareEventFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [Event__id_getInstance(), Event_time_getInstance(), Event_type_getInstance(), Event_target_getInstance()];
  var tmp = Companion_instance.k2a();
  properties(tmp, (it) => props);
}
function Event__id$name$delegate$lambda() {
  return Companion_instance.k2a().az().v11(0);
}
function Event__id$_get_name_$ref_krylni() {
  return (p0) => p0.i20();
}
function Event__id$serializer$delegate$lambda() {
  var tmp = Companion_instance.k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Event__id$_get_serializer_$ref_6t0q5z() {
  return (p0) => p0.h2j();
}
function Event__id$annotations$delegate$lambda() {
  return Companion_instance.k2a().az().x11(0);
}
function Event__id$_get_annotations_$ref_i7epar() {
  return (p0) => p0.bz();
}
var Event__idClass;
function Event__id() {
  if (Event__idClass === VOID) {
    class $ {
      constructor() {
        Event__id_instance = this;
        var tmp = this;
        tmp.c8j_1 = lazy(Event__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.d8j_1 = lazy(Event__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.e8j_1 = lazy(Event__id$annotations$delegate$lambda);
        this.f8j_1 = Companion_getInstance().k2p();
        this.g8j_1 = 'UUID.random()';
      }
      i20() {
        var tmp0 = this.c8j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Event__id$_get_name_$ref_krylni(), null);
        return tmp0.f2();
      }
      h8j(receiver) {
        return receiver.i8j_1;
      }
      k2j(receiver) {
        return this.h8j(receiver instanceof Event() ? receiver : THROW_CCE());
      }
      m8j(receiver, value) {
        return receiver.n8j(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof Event() ? receiver : THROW_CCE();
        return this.m8j(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.d8j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Event__id$_get_serializer_$ref_6t0q5z(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.e8j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Event__id$_get_annotations_$ref_i7epar(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'Event__id', VOID, VOID, [SerializableProperty()]);
    Event__idClass = $;
  }
  return Event__idClass;
}
var Event__id_instance;
function Event__id_getInstance() {
  if (Event__id_instance === VOID)
    new (Event__id())();
  return Event__id_instance;
}
function Event_time$name$delegate$lambda() {
  return Companion_instance.k2a().az().v11(1);
}
function Event_time$_get_name_$ref_3xpd33() {
  return (p0) => p0.i20();
}
function Event_time$serializer$delegate$lambda() {
  var tmp = Companion_instance.k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Event_time$_get_serializer_$ref_ah5ml6() {
  return (p0) => p0.h2j();
}
function Event_time$annotations$delegate$lambda() {
  return Companion_instance.k2a().az().x11(1);
}
function Event_time$_get_annotations_$ref_ojp5t6() {
  return (p0) => p0.bz();
}
var Event_timeClass;
function Event_time() {
  if (Event_timeClass === VOID) {
    class $ {
      constructor() {
        Event_time_instance = this;
        var tmp = this;
        tmp.o8j_1 = lazy(Event_time$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.p8j_1 = lazy(Event_time$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.q8j_1 = lazy(Event_time$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.o8j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Event_time$_get_name_$ref_3xpd33(), null);
        return tmp0.f2();
      }
      h8j(receiver) {
        return receiver.j8j_1;
      }
      k2j(receiver) {
        return this.h8j(receiver instanceof Event() ? receiver : THROW_CCE());
      }
      r8j(receiver, value) {
        return receiver.n8j(VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof Event() ? receiver : THROW_CCE();
        return this.r8j(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.p8j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Event_time$_get_serializer_$ref_ah5ml6(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.q8j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Event_time$_get_annotations_$ref_ojp5t6(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'Event_time', VOID, VOID, [SerializableProperty()]);
    Event_timeClass = $;
  }
  return Event_timeClass;
}
var Event_time_instance;
function Event_time_getInstance() {
  if (Event_time_instance === VOID)
    new (Event_time())();
  return Event_time_instance;
}
function Event_type$name$delegate$lambda() {
  return Companion_instance.k2a().az().v11(2);
}
function Event_type$_get_name_$ref_cgpmyc() {
  return (p0) => p0.i20();
}
function Event_type$serializer$delegate$lambda() {
  var tmp = Companion_instance.k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Event_type$_get_serializer_$ref_giyjzn() {
  return (p0) => p0.h2j();
}
function Event_type$annotations$delegate$lambda() {
  return Companion_instance.k2a().az().x11(2);
}
function Event_type$_get_annotations_$ref_v7nwdl() {
  return (p0) => p0.bz();
}
var Event_typeClass;
function Event_type() {
  if (Event_typeClass === VOID) {
    class $ {
      constructor() {
        Event_type_instance = this;
        var tmp = this;
        tmp.s8j_1 = lazy(Event_type$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.t8j_1 = lazy(Event_type$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.u8j_1 = lazy(Event_type$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.s8j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Event_type$_get_name_$ref_cgpmyc(), null);
        return tmp0.f2();
      }
      h8j(receiver) {
        return receiver.k8j_1;
      }
      k2j(receiver) {
        return this.h8j(receiver instanceof Event() ? receiver : THROW_CCE());
      }
      v8j(receiver, value) {
        return receiver.n8j(VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof Event() ? receiver : THROW_CCE();
        return this.v8j(tmp, value instanceof EventType() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.t8j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Event_type$_get_serializer_$ref_giyjzn(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.u8j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Event_type$_get_annotations_$ref_v7nwdl(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'Event_type', VOID, VOID, [SerializableProperty()]);
    Event_typeClass = $;
  }
  return Event_typeClass;
}
var Event_type_instance;
function Event_type_getInstance() {
  if (Event_type_instance === VOID)
    new (Event_type())();
  return Event_type_instance;
}
function Event_target$name$delegate$lambda() {
  return Companion_instance.k2a().az().v11(3);
}
function Event_target$_get_name_$ref_jpx56r() {
  return (p0) => p0.i20();
}
function Event_target$serializer$delegate$lambda() {
  var tmp = Companion_instance.k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Event_target$_get_serializer_$ref_mptn6e() {
  return (p0) => p0.h2j();
}
function Event_target$annotations$delegate$lambda() {
  return Companion_instance.k2a().az().x11(3);
}
function Event_target$_get_annotations_$ref_m6anrm() {
  return (p0) => p0.bz();
}
var Event_targetClass;
function Event_target() {
  if (Event_targetClass === VOID) {
    class $ {
      constructor() {
        Event_target_instance = this;
        var tmp = this;
        tmp.w8j_1 = lazy(Event_target$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.x8j_1 = lazy(Event_target$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.y8j_1 = lazy(Event_target$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.w8j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Event_target$_get_name_$ref_jpx56r(), null);
        return tmp0.f2();
      }
      h8j(receiver) {
        return receiver.l8j_1;
      }
      k2j(receiver) {
        return this.h8j(receiver instanceof Event() ? receiver : THROW_CCE());
      }
      z8j(receiver, value) {
        return receiver.n8j(VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof Event() ? receiver : THROW_CCE();
        return this.z8j(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.x8j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Event_target$_get_serializer_$ref_mptn6e(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.y8j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Event_target$_get_annotations_$ref_m6anrm(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'Event_target', VOID, VOID, [SerializableProperty()]);
    Event_targetClass = $;
  }
  return Event_targetClass;
}
var Event_target_instance;
function Event_target_getInstance() {
  if (Event_target_instance === VOID)
    new (Event_target())();
  return Event_target_instance;
}
//region block: exports
export {
  prepareEventFields as prepareEventFieldsuypk88vril5i,
};
//endregion

//# sourceMappingURL=EventFields.mjs.map
